const STORAGE_KEY_PREFIX = 'guest_pricing_session_id:';

export const getOrCreateGuestPricingSessionId = (
  restaurantId: string,
): string => {
  const key = `${STORAGE_KEY_PREFIX}${restaurantId}`;
  const existing = sessionStorage.getItem(key);
  if (existing) {
    return existing;
  }
  const id = crypto.randomUUID();
  sessionStorage.setItem(key, id);
  return id;
};
